import axios, { AxiosError } from "axios";
import { GET_COURSE_DEFINITION_LIST, GET_COURSE_INSTANCE_DEFINITION_LIST, GET_COURSE_COUNT_CARD, DELETE_COURSE_DEFINITION_API, DELETE_COURSE_INSTANCE_API, GET_VM_LIST, REPLACE_VM_API, GET_XTOKEN } from "../../../../../../src/common/apiEndPoint/apiEndPoint";
import config from "../../../../../common/authentication/config";
import AuthProvider from "../../../../../common/authentication/authService";

export const orgNameStatic = config?.ACADEMY_ORGNAME;
export const siteIdStatic = config?.SITE_ID;

axios.interceptors.request.use((config) => {
  const token = AuthProvider().getAccessToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const cookieVal = () => {
  const cookie = AuthProvider().getCookie("XSRF-TOKEN");
  if (cookie !== "") {
    return cookie;
  }
};

export const getCourseCountData = async (requestParams: any) => {
  try {
    const res: any = await axios.get(`${GET_COURSE_COUNT_CARD}`,
      {
        headers: {
          Authorization: `Bearer ${requestParams?.accessToken}`,
          Accept: "application/json",
          OrgName: orgNameStatic,
          SiteId: siteIdStatic,
          "X-XSRF-TOKEN": cookieVal(),
        },
      }
    );
      return {
        success: true,
        data: res.data.courseCountData || []
      };
  } catch (error) { 
    return {
      success: false,
      status: (error as AxiosError)?.status || 500,
      message: (error as AxiosError)?.response?.data || "Unknown error occurred",
    }
  }
};

export const getCourseViewTemplateData = async (requestParams: any) => {
  try {
    const pageSize = requestParams.pageSize || 200;
    const pageNumber = requestParams.pageNumber;
    let courseStage = '';
    if(requestParams.courseStage === "Published"){
      courseStage = "Published";
    } else if(requestParams.courseStage === "Draft"){
      courseStage = "Draft";
    } else {
      courseStage = "All";
    }
    
    // Build URL with search parameters if provided
    let url = `${GET_COURSE_DEFINITION_LIST}?pageNo=${pageNumber}&pageSize=${pageSize}&courseStage=${courseStage}`;
    
    // Add search parameters if searchValue is provided and not empty
    if (requestParams.searchValue && requestParams.searchValue.trim() !== '') {
      const searchBy = requestParams.searchBy !== undefined ? requestParams.searchBy : 0;
      url += `&searchBy=${searchBy}&searchValue=${encodeURIComponent(requestParams.searchValue)}`;
    }
    
    // Add sortBy parameter only if explicitly provided
    if (requestParams.sortBy !== undefined) {
      url += `&sortBy=${requestParams.sortBy}`;
    }
    
    const res: any = await axios.get(
      url,
      {
        headers: {
          Authorization: `Bearer ${requestParams.accessToken}`,
          Accept: "application/json",
          OrgName: orgNameStatic,
          SiteId: siteIdStatic,
          "X-XSRF-TOKEN": cookieVal(),
        }
      }
    );
    return {
      success: true,
      data: res.data
    }
  } catch (error) {
    return {
      success: false,
      status: (error as AxiosError)?.status || 500,
      message: (error as AxiosError)?.response?.data || "Unknown error occured",
    }
  }
};

export const getCourseInstanceViewTemplateData = async (requestParams: any) => {
  try {
    if (!requestParams) {
      throw new Error("requestParams is required");
    }

    const { pageNumber, pageSize, accessToken, searchValue, searchBy, sortBy } = requestParams;
    
    // Build URL with search parameters if provided
    let url = `${GET_COURSE_INSTANCE_DEFINITION_LIST}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    
    // Add search parameters if searchValue is provided and not empty
    if (searchValue && searchValue.trim() !== '') {
      const searchByValue = searchBy !== undefined ? searchBy : 0;
      url += `&searchBy=${searchByValue}&searchValue=${encodeURIComponent(searchValue)}`;
    }
    
    // Add sortBy parameter only if explicitly provided
    if (sortBy !== undefined) {
      url += `&sortBy=${sortBy}`;
    }
    
    const res: any = await axios.get(
      url,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: "application/json",
          OrgName: orgNameStatic,
          SiteId: siteIdStatic,
          "X-XSRF-TOKEN": cookieVal()
        },
      }
    );
    return {
      success: true,
      data: res.data
    }
  } catch (error) {
    return {
      success: false,
      status: (error as AxiosError)?.status || 500,
      message: (error as AxiosError)?.response?.data || "Unknown error occured",
    }
  }
};

export const deleteCourseTemplate = async (requestParams: any) => {
  try {
    const res: any = await axios.delete(
      `${DELETE_COURSE_DEFINITION_API}`,
      {
        data: requestParams,
        headers: {
          Authorization: `Bearer ${requestParams?.accessToken}`,
          Accept: "application/json",
          OrgName: orgNameStatic,
          SiteId: siteIdStatic,
          "X-XSRF-TOKEN": cookieVal(),
        }
      }
    );
    return {
      status: res.status,
      message: res.data
    };
  } catch (error) {
    const axiosError = error as AxiosError<{ message?: string }>;
    return {
      status: axiosError.response?.status,
      message: axiosError.response?.data,
    };
   }
};

export const deleteCourseInstance = async (requestParams: any) => {
  try {
    const res: any = await axios.delete(
      `${DELETE_COURSE_INSTANCE_API}`,
      {
        data: requestParams,
        headers: {
          Authorization: `Bearer ${requestParams?.accessToken}`,
          Accept: "application/json",
          OrgName: orgNameStatic,
          SiteId: siteIdStatic,
          "X-XSRF-TOKEN": cookieVal(),
        }
      }
    );
    return {
      status: res.status,
      message: res.data.message
    };
  } catch (error) {
    const axiosError = error as AxiosError<{ message?: string }>;
    return {
      status: axiosError.response?.status,
      message: axiosError.response?.data,
    };
  }
}

export const GetVmListBySiteId = async (requestParams: any) => {
  try {
    const res: any = await axios.get(
      `${GET_VM_LIST}?siteId=${requestParams?.siteId}`,
      {
        data: requestParams,
        headers: {
          Authorization: `Bearer ${requestParams?.accessToken}`,
          Accept: "application/json",
          OrgName: orgNameStatic,
          SiteId: siteIdStatic
        }
      }
    );
    return {
      status: res.status,
      data: res.data
    };
  } catch (error) {
    const axiosError = error as AxiosError<{ message?: string }>;
    return {
      status: axiosError.response?.status,
      message: axiosError.response?.data,
    };
  }
}

export const ReplaceVm = async (requestParams: any) => {
  try {
    if (!requestParams) {
      throw new Error("requestParams is required");
    }

    const { vmIdToAdd, vmIdToDelete, accessToken, siteId } = requestParams;

    const body = {
      vmIdToAdd,
      vmIdToDelete,
    };

    const res: any = await axios.post(REPLACE_VM_API, body, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "X-XSRF-TOKEN": cookieVal(),
        Accept: "application/json",
        SiteId: siteIdStatic,
        orgsiteId: siteId
      },
    });

    return {
      status: res.data.statusCode,
      message: res.data.message
    };
  } catch (error) {
    throw error;
  }
}
